const t = null;
export {
  t as default
};
